const NO_DESCRIPTION_MESSAGE = "Description not currently displayed.";

export function formatGenericIngredientDescription(
  description: string | null | undefined,
  status: string | null | undefined,
  record: string | null | undefined,
  allocationMethod?: string | null,
  databaseName?: string | null
): string {
  const parts: string[] = [];

  parts.push(description?.trim() ? description.trim() : NO_DESCRIPTION_MESSAGE);

  if (status?.trim()) {
    parts.push(`Status: ${status.trim()}`);
  }
  if (record?.trim()) {
    parts.push(`Record: ${record.trim()}`);
  }

  parts.push(
    [
      `Allocation method: ${allocationMethod?.trim() || "Not Available"}`,
      `Database name: ${databaseName?.trim() || "Not Available"}`
    ].join("\n")
  );

  return parts.join("\n\n");
}
